// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav--1VNM0"};